/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { RESTService, ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Post request to path:
 * /v1/dbs/files
 *
 * @param {any} data
 * @param {Object} headers to send
 * @param {any} callback function to call once this function has finished
 */
const postDbsFilesUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/dbs/files`;

  RESTService.post(
    url,
    data.file,
    (success, body, header) => {
      callback(success, body, header);
    },
    '*/*',
    null,
    data.metadataHeaders
  );
};

/**
 * Gets SPMFileDownloadContents from api:
 * /v1/dbs/files/{fileId}
 *
 * @param {string} fileId.
 * @param {any} callback function to call once this function has finished
 */
const getDbsFilesByFileIdUtil = (fileId, callback) => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/dbs/files/${fileId}`,
    models.SPMFileDownloadContents
  );
};

/**
 * Deletes from api:
 * /v1/dbs/files/{fileId}
 *
 * @param {string} fileId.
 * @param {any} callback function to call once this function has finished
 */
const deleteDbsFilesByFileIdUtil = (fileId, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/dbs/files/${fileId}`;
  RESTService.del(url, (success, response) => {
    callback(success, response);
  });
};

export { postDbsFilesUtil, getDbsFilesByFileIdUtil, deleteDbsFilesByFileIdUtil };
